import React from 'react';
import { Text, View, Platform } from 'react-native';

import PropTypes from 'prop-types';

import FoundationTestKeys from '../../../FoundationTestKeys';

import styles from './ViewMoreText.Styles';

class ViewMoreText extends React.Component {
  state = {
    isTextShown: false,
    isTextMoreInLength: false,
  };

  onTextLayout = e => {
    const { numberOfLines } = this.props;
    this.setState({
      isTextMoreInLength: e.nativeEvent.lines.length > numberOfLines,
    });
  };
  onPressMore = () => {
    this.toggleIsTextShown();
  };

  onPressLess = () => {
    this.toggleIsTextShown();
  };
  toggleIsTextShown = () => {
    const { isTextShown } = this.state;
    this.setState({ isTextShown: !isTextShown });
  };
  renderViewMore = () => (
    <Text onPress={this.onPressMore} testID={FoundationTestKeys.viewMore}>
      View More
    </Text>
  );

  renderViewLess = () => (
    <Text onPress={this.onPressLess} testID={FoundationTestKeys.viewLess}>
      View Less
    </Text>
  );

  renderFooter = () => {
    const { numberOfLines, renderViewMore, renderViewLess } = this.props;
    const { isTextMoreInLength, isTextShown } = this.state;
    if (isTextMoreInLength || numberOfLines === 0) {
      if (isTextShown) {
        return (renderViewLess || this.renderViewLess)(this.onPressLess);
      }
      return (renderViewMore || this.renderViewMore)(this.onPressMore);
    }
    return null;
  };

  renderIOS() {
    //in IOS the value of 'e.nativeEvent.lines.length' in 'onTextLayout' indicates the number of lines after truncating, so we cannot use that directly
    //we need to render the text twice, the first one will be invisible and will be used to calculate the number of lines of the text without any truncating
    const { numberOfLines, textStyle, children } = this.props;
    const { isTextShown } = this.state;
    return (
      <View>
        <Text
          onTextLayout={this.onTextLayout}
          style={[textStyle, styles.hiddenText]}
          testID={FoundationTestKeys.viewMoreTextTestID}
        >
          {children}
        </Text>
        {(numberOfLines > 0 || (numberOfLines === 0 && isTextShown)) && (
          <Text numberOfLines={isTextShown ? undefined : numberOfLines} style={textStyle}>
            {children}
          </Text>
        )}
        {this.renderFooter()}
      </View>
    );
  }

  renderAndroid() {
    //in android, the value of 'e.nativeEvent.lines.length' in 'onTextLayout' indicates the number of lines without truncating, so we can use that directly
    const { numberOfLines, textStyle, children } = this.props;
    const { isTextShown } = this.state;
    return (
      <View>
        {(numberOfLines > 0 || (numberOfLines === 0 && isTextShown)) && (
          <Text
            onTextLayout={this.onTextLayout}
            numberOfLines={isTextShown ? undefined : numberOfLines}
            style={textStyle}
          >
            {children}
          </Text>
        )}
        {this.renderFooter()}
      </View>
    );
  }

  render() {
    if (Platform.OS === 'ios') {
      return this.renderIOS();
    }
    return this.renderAndroid();
  }
}

ViewMoreText.propTypes = {
  children: PropTypes.node,
  renderViewMore: PropTypes.func,
  renderViewLess: PropTypes.func,
  numberOfLines: PropTypes.number.isRequired,
  textStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

ViewMoreText.defaultProps = {
  textStyle: {},
};

export default ViewMoreText;
